export default "__VITE_ASSET__BYabY1vx__"